/* eslint-disable prefer-template, no-nested-ternary, no-else-return */

import { getCountryByCode, getCountryCode, isPopulated } from '@gameday/common/functions'
import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'
import { parsePhoneNumberFromString } from 'libphonenumber-js/min'
import React from 'react'
import Input from 'react-phone-number-input/input'
import styled from 'styled-components'

import 'react-phone-number-input/style.css'

import CountrySelect from '../CountrySelect'
import LabelWrapper from '../LabelWrapper'

const InternationalIcon = () => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: TODO
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 50">
    <path
      stroke="none"
      fill="currentColor"
      d="M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
    />
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10">
      <path stroke-linecap="round" d="M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3" />
      <path d="M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3" />
      <line x1="26" y1="25" x2="74" y2="25" />
      <line x1="50" y1="1" x2="50" y2="49" />
      <path
        stroke-linecap="round"
        d="M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
      />
      <path
        stroke-linecap="round"
        d="M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
      />
    </g>
  </svg>
)

const styles = theme => ({
  phoneInput: {
    '& .full-width $singleInput': {
      width: '100%',
      backgroundColor: `var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`,
    },
    '& .wrapped:not(.bordered)': {
      borderBottom: theme.borders.default,
      '&.has-error': {
        borderColor: theme.borders.borderColorError,
        '& input, & .country-select__control': {
          backgroundColor: 'transparent',
        },
      },
      '& input:hover, & input:focus': {
        backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
      },
      '& .country-select__control, & .country-select__control--is--focused': {
        border: 0,
        boxShadow: 'none',
        '&:focus': {
          border: 0,
        },
      },
    },
    '&:focus-within .wrapped:not(.bordered)': {
      borderColor: theme.borders.borderColorActive,
    },
    '& .has-error': {
      '& .country-select__control, & $singleInput': {
        borderColor: theme.status.errorColor,
        backgroundColor: `${`var(--gameday-inputField-inputBGError, ${theme.inputField.inputBGError})`} !important`,
      },
    },
    '& .PhoneInputCountry': {
      margin: '0',
      padding: '0 10px',
      border: props => (props.withBorder ? theme.borders.default : 'none'),
      borderRadius: '4px 0 0 4px',
    },
    '&:focus-within .PhoneInputCountry': {
      borderRightColor: theme.borders.borderColorActive,
    },
    '& .country-select-wrapper': {
      marginRight: '-1px !important',
      flex: '0 1 120px',
      '& .country-select__control': {
        width: '100%',
        borderRadius: '4px 0 0 4px',
      },
    },
    '& .country-select__indicators': {
      width: '24px',
    },
    '& input': {
      borderRadius: '0 4px 4px 0',
    },
    '& .error-text': {
      width: '100% !important',
    },
    '& .disabled': {
      '& $fieldWrap:hover': {
        cursor: 'not-allowed',
      },
      '& input, & input:hover': {
        backgroundColor: `${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`} !important`,
      },
    },
  },
  singleInput: {
    // width: props => props.customWidth && props.customWidth,
    height: '36px',
    padding: '0 0 0 10px',
    outline: 'none',
    border: props => (props.withBorder ? theme.borders.default : 'none'),
    borderRadius: theme.borders.borderRadius,
    fontFamily: theme.typography.defaultFont,
    fontSize: theme.typography.fontSizeSm,
    color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
    '-webkit-appearance': 'none',
    '&:focus-within': {
      borderColor: theme.borders.borderColorActive,
      borderLeftColor: `var(--gameday-inputField-inputBorderActive, ${theme.inputField.inputBorderActive}) !important`,
    },
  },
  countrySelect: {
    // width: props => props.customWidth && props.customWidth,
    height: '36px',
    '-webkit-appearance': 'none',
    '& input': {
      marginLeft: '-1px',
      padding: '0 0 0 10px',
      outline: 'none',
      border: props => (props.withBorder ? theme.borders.default : 'none'),
      fontFamily: theme.typography.defaultFont,
      fontSize: theme.typography.fontSizeSm,
      color: `var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`,
      borderRadius: '0 4px 4px 0',
      '&:focus': {
        borderColor: theme.borders.borderColorActive,
      },
    },
    '& .country-select__value-container': {
      display: 'flex',
      flex: '1 1 118px',
      minWidth: '90px',
      maxWidth: '118px',
      height: '34px',
      padding: '0',
      overflow: 'hidden',
      // flex: 'auto',
      flexWrap: 'nowrap',
      '& > div': {
        width: '100%',
        height: '34px',
      },
      '& .country-emoji': {
        display: 'inline-block',
        flex: '0 0 30px',
        padding: '0 6px',
        marginRight: '0 !important',
      },
      '& .country-selected-value': {
        display: 'block',
        // width: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        lineHeight: '36px',
        flex: '1 1 100%',
      },
    },
    '& .country-select__indicator-separator': {
      display: 'none',
    },
    '& .country-select__control': {
      flexWrap: 'nowrap',
      minHeight: '36px',
      '&.country-select__control--is-focused': {
        boxShadow: 'none !important',
        borderColor: theme.borders.borderColorActive,
      },
      '&.country-select__control--is-disabled': {
        backgroundColor: `${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`} !important`,
        borderColor: 'rgb(204, 204, 204)',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
  fieldWrap: {
    display: 'flex',
    width: props => (props.customWidth ? props.customWidth : props.fullWidth && '100%'),
  },
})

const Placeholder = styled.img`
  width: 32px;
  margin-top: 4px;
`

class PhoneNumber extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      phoneNumber: '',
      country: '',
    }
  }

  componentDidMount() {
    const { value } = this.props

    if (isPopulated(value)) {
      const phoneNumberObj = parsePhoneNumberFromString(String(value))

      // biome-ignore lint/complexity/useOptionalChain: TODO
      if (phoneNumberObj !== undefined && phoneNumberObj.isValid()) {
        this.setState({
          country: getCountryByCode(phoneNumberObj.country),
          phoneNumber: phoneNumberObj.number,
        })
      }
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { country, phoneNumber } = prevState
    const { value } = nextProps
    const phoneNumberValue = typeof value === 'string' ? value : value.value

    if (phoneNumberValue !== phoneNumber) {
      // when new value comes
      const phoneNumberObj = parsePhoneNumberFromString(String(phoneNumberValue))

      // biome-ignore lint/complexity/useOptionalChain: TODO
      if (phoneNumberObj !== undefined && phoneNumberObj.isValid()) {
        // if new value is valid or hit cancel with empty phone number value or with new phone number value
        return {
          phoneNumber: phoneNumberObj.number,
          country: getCountryByCode(phoneNumberObj.country),
        }
      } else if (!isPopulated(phoneNumberValue) && phoneNumberValue !== phoneNumber) {
        // if new value is empty string value, resets the state
        return { phoneNumber: '', country: '' }
      }
    } else if (typeof value === 'string' && isPopulated(phoneNumberValue) && phoneNumberValue === phoneNumber) {
      // when user has updated country for the phone number with number existing,
      // then click Cancel, needs to revert back country state
      const phoneNumberObj = parsePhoneNumberFromString(String(phoneNumberValue))

      // biome-ignore lint/complexity/useOptionalChain: TODO
      if (phoneNumberObj !== undefined && phoneNumberObj.isValid() && phoneNumberObj.country !== country.code) {
        return {
          country: getCountryByCode(phoneNumberObj.country),
        }
      }
    } else if (typeof value === 'string' && country !== '') {
      // when user changed the country for new phone number, then click Cancel
      return { country: '' }
    }
    return null
  }

  handleNumberChange = val => {
    const { defaultCountry, onNumberChange } = this.props
    const { country } = this.state
    if (val) {
      onNumberChange({
        value: val,
        countryCode: country ? country.code : defaultCountry ? getCountryCode(defaultCountry) : '',
      })
      this.setState({ phoneNumber: val })
    } else {
      this.setState({ phoneNumber: '' })
      onNumberChange({
        value: '',
        countryCode: '',
      })
    }
  }

  onCountryChange = (country, phoneNumber) => {
    const { onNumberChange } = this.props
    // Check if current phone number is valid with new country value or not
    const phoneNumberObj = parsePhoneNumberFromString(String(phoneNumber))
    const newPhoneNumber =
      // biome-ignore lint/complexity/useOptionalChain: TODO
      country && country.phone && phoneNumberObj && phoneNumberObj.nationalNumber
        ? // biome-ignore lint/style/useTemplate: TODO
          '+' + country.phone + phoneNumberObj.nationalNumber
        : ''
    const phoneNumberObj2 = parsePhoneNumberFromString(String(newPhoneNumber))

    // If current phone number value is still valid with new country, sets phone number with new country code
    // if not valid, keep the current value and validation will be thrown saying invalid phone number
    this.setState({
      country,
      // biome-ignore lint/complexity/useOptionalChain: TODO
      phoneNumber: phoneNumberObj2 && phoneNumberObj2.isValid() ? phoneNumberObj2.number : phoneNumber,
    })
    onNumberChange({
      countryCode: country ? country.code : '',
      // biome-ignore lint/complexity/useOptionalChain: TODO
      value: phoneNumberObj2 && phoneNumberObj2.isValid() ? phoneNumberObj2.number : phoneNumber,
    })
  }

  render() {
    const {
      classes,
      className,
      customCol,
      customMargin,
      customPadding,
      customWidth,
      countries,
      dataTestId,
      defaultCountry,
      disabled,
      errorText,
      fieldLabel,
      fullWidth,
      handleClear,
      helperText,
      id,
      isClearable,
      isLabelInline,
      isRequired,
      isToolTip,
      label,
      labelIcon,
      limitMaxLength,
      noMobile,
      notWrapper,
      noWrap,
      onBlur,
      placeholder,
      showClear,
      spacing,
      toolTipIcon,
      toolTipPosition,
      toolTipText,
      variant,
      withBorder,
      withDivider,
      withFlags,
      ...rest
    } = this.props
    const { country, phoneNumber } = this.state

    return (
      <LabelWrapper
        className={cn([classes.phoneInput], className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        errorText={errorText}
        fieldLabel={fieldLabel}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        label={label}
        labelIcon={labelIcon}
        multipleFields
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        showClear={showClear}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        variant={variant}
        withBorder={withBorder}
        withDivider={withDivider}
        {...rest}
      >
        <div className={classes.fieldWrap}>
          <CountrySelect
            className={classes.countrySelect}
            countries={countries}
            countryLabelType="phone"
            defaultCountry={defaultCountry}
            disabled={disabled}
            handleClear={handleClear}
            isClearable={isClearable}
            isSearchable={false}
            noLabel
            placeholder={<Placeholder src={InternationalIcon} />}
            onChange={country => this.onCountryChange(country.selectedOption, phoneNumber)}
            value={country || getCountryByCode(defaultCountry)}
            withFlags={withFlags}
            id={id}
          />
          <Input
            className={cn(classes.singleInput, 'PhoneNumber-singleInput')}
            value={phoneNumber}
            onChange={e => this.handleNumberChange(e)}
            defaultCountry={defaultCountry ? getCountryCode(defaultCountry) : ''}
            // biome-ignore lint/complexity/useOptionalChain: TODO
            country={country && country.code}
            displayInitialValueAsLocalNumber
            placeholder={placeholder}
            disabled={disabled}
            limitMaxLength={limitMaxLength}
            onBlur={onBlur}
            id={`${id}-phone-input`}
            data-testid={dataTestId}
          />
        </div>
      </LabelWrapper>
    )
  }
}

PhoneNumber.defaultProps = {
  // customWidth: 90,
  defaultCountry: null,
  isClearable: false,
  limitMaxLength: true,
  // eslint-disable-next-line no-console
  onNumberChange: e => console.log(e),
  onBlur: () => {},
}

const PhoneNumberComponent = withStyles(styles)(PhoneNumber)
PhoneNumberComponent.displayName = 'PhoneNumber'
export default PhoneNumberComponent
